import React, { Component } from "react";
import TextMessage from "./TextMessage";
import ReplyTextMessage from "./ReplyTextMessage";
import DoneIcon from "@material-ui/icons/Done";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import appConstants from "../../../../../appConstants"
import { utcToZonedTime } from "date-fns-tz";
import { format } from "date-fns";

class Message extends Component {
  renderMessageOfType(data) {
    if (Object.keys(data.parentMessage).length === 0) {
      return (
        <TextMessage
          msg={data}
          name={this.props.name}
          metadataColor={this.props.metadataColor}
          classes={this.props.classes}
          onReplyMsgSelected={this.props.onReplyMsgSelected}
          convertTime={this.convertTime}
          renderReadIcon={this.renderReadIcon}
        />
      );
    } else {
      return (
        <ReplyTextMessage
          msg={data}
          classes={this.props.classes}
          name={this.props.name}
          metadataColor={this.props.metadataColor}
          convertTime={this.convertTime}
          renderReadIcon={this.renderReadIcon}
        />
      );
    }
  }

  convertTime = (time) => {
    return format(
      utcToZonedTime(time, this.props.terminalOffset),
      appConstants.DATETYPES.TIME.format
    );
  };

  renderReadIcon = (isRead, classes) => {
    if (isRead === true) {
      return <DoneAllIcon className={classes.iconStyle}></DoneAllIcon>;
    } else {
      return <DoneIcon className={classes.iconStyle}></DoneIcon>;
    }
  };
  render() {
    const { classes, unReadCount, messageNumber, message } = this.props;
    const msg = message.message;
    if (!msg) {
      return null;
    }
    return (
      <div className={classes.scMessage}>
        <div
          className={`${classes.scMessageContent} ${
            message.messageType === appConstants.MESSAGE_TYPE.Dispatcher
              ? "scMessageContentSent"
              : "sc_message__content_received"
          }`}
        >
          {message && this.renderMessageOfType(message)}
        </div>
        {unReadCount === messageNumber && unReadCount > 0 && (
          <div className={classes.unReadMsg} ref={this.props.unReadMessageRef}>{unReadCount} Unread Message</div>
        )}
      </div>
    );
  }
}
export default Message;
